<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" v-loading="loading" :element-loading-text="loadTxt">
      <myHeader ref="myHeader"></myHeader>
      <!-- 添加 -->
      <div class="MobelBox" v-if="addType == 'add' || addType == 'exit'">
        <div class="write-txt">
          <p class="write-title">标题<span>*</span></p>
          <div class="write-text">
            <textarea v-model="addObj.title"
              placeholder="最多输入30个中/英、数字和特殊符号"
            ></textarea>
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">副标题<span>*</span></p>
          <div class="write-text">
            <textarea v-model="addObj.subtitle"
              placeholder="最多输入30个中/英、数字和特殊符号"
            ></textarea>
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">类型<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.type_id" placeholder="请选择">
              <el-option
                v-for="item in typelist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span>请选择</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">上传封面<span>*</span></p>
          <div class="write-text">
            <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
              <img :src="'https://speakiopic.zens10.com/'+addObj.image" alt="">
              <div class="hover" v-if="imgType">
                <i class="icon-delete" @click="imgRemove"></i>
              </div>
            </div>
            <el-upload
              :action="'https://up-as0.qiniup.com'"
              :data="uploadObj"
              list-type="picture-card"
              :before-upload="beforeUploadImg"
              :on-success="handleSuccessImg"
              :on-progress="handleProgressImg"
              :on-remove="handleRemoveImg"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img
                width="100%"
                :src="'https://speakiopic.zens10.com/' + addObj.image"
                alt=""
              />
            </el-dialog>
          </div>
        </div>
        <div class="write-txt" v-for="(item,index) in addObj.static_videos" :key="index">
          <p class="write-title">上传{{item.name}}静态视频<span>*</span></p>
          <div class="write-text">
            <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="item.video">
              <video :src="'https://speakiopic.zens10.com/'+item.video" alt=""></video>
              <div class="hover" v-if="imgType">
                <i class="icon-delete" @click="imgRemove"></i>
              </div>
            </div>
            <el-upload
              :action="'https://up-as0.qiniup.com'"
              :data="uploadObj"
              list-type="picture-card"
              :before-upload="beforeUploadVideo"
              :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index,'num')}"
              :on-progress="handleProgressImg"
              :on-remove="handleRemoveVideo"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img
                width="100%"
                :src="'https://speakiopic.zens10.com/' + addObj.static_video"
                alt=""
              />
            </el-dialog>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">选择功能<span>*</span></p>
          <div class="write-text">
            <!-- <el-checkbox-group @change="checkSub($event)"> -->
              <!-- <el-checkbox v-for="item in checkList" :label="item.title" :key="item.id"></el-checkbox> -->
               <!-- {{checkList}} -->
              <el-checkbox v-for="(ele,num) in checkList" v-bind:key="ele.id" v-model="ele.checked">{{ele.title}}</el-checkbox>
            <!-- </el-checkbox-group> -->
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="ModelHide">取消</button>
        </div>
      </div>

      <!-- 说明 -->
      <div class="MobelBox" v-if="addType == 'describe'">
        <div class="write-txt" v-for="(item,index) in describeObj.videos" :key="index">
          <p class="write-title">上传{{item.name}}动态视频<span>*</span></p>
          <div class="write-text">
            <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="item.video">
              <video :src="'https://speakiopic.zens10.com/'+item.video" alt=""></video>
              <div class="hover" v-if="imgType">
                <i class="icon-delete" @click="imgRemove"></i>
              </div>
            </div>
            <el-upload
              :action="'https://up-as0.qiniup.com'"
              :data="uploadObj"
              list-type="picture-card"
              :before-upload="beforeUploadVideo"
              :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index,'num')}"
              :on-progress="handleProgressImg"
              :on-remove="handleRemoveVideo"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img
                width="100%"
                :src="'https://speakiopic.zens10.com/' + describeObj.video"
                alt=""
              />
            </el-dialog>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">初始要点说明<span>*</span></p>
          <div class="write-text">
            <textarea v-model="describeObj.content"
              placeholder="最多输入1000个中/英、数字和特殊符号"
            ></textarea>
            <span>最多输入1000个中/英、数字和特殊符号</span>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="describeSub">保存</button>
          <button class="btn btn-close" @click="ModelHide">取消</button>
        </div>
      </div>

      <!-- 提问 -->
      <div class="MobelBox questionBox" v-if="addType == 'question'">
        <div class="write-txt">
          <p class="write-title">生成演讲稿提示词<span>*</span></p>
          <div class="write-text" style="margin: 11px 0 0;">
            <textarea v-model="questionObj.speech_text_ai" 
              placeholder=""
            ></textarea>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">挑战问题提示词<span>*</span></p>
          <div class="write-text" style="margin: 11px 0 0;">
            <textarea v-model="questionObj.challenge_problem_ai" 
              placeholder=""
            ></textarea>
          </div>
        </div>
        <div class="write-txt write-num">
          <p class="write-title">进度数量<span>*</span></p>
          <div class="write-text">
            <div style="display: inline-block;vertical-align: top;margin-right: 30px;">
              <input type="number" v-model="questionObj.progress_num" class="progress_num">
              <span>请输入1～50正整数</span>
            </div>
            <button class="btn btn-create" @click="createSub">生成</button>
          </div>
        </div>
        <div class="uploadList" v-for="(item,index) in questionObj.progress" v-bind:key="item.id">
          <div class="upload-item">
            <p class="upload-title">进度{{(index+1)}}</p>
            <div class="write-txt question-title" v-for="(ele,num) in item.videos" :key="num">
              <p class="write-title">上传{{ele.name}}视频<span>*</span></p>
              <div class="write-text">
                <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="ele.video">
                  <video :src="'https://speakiopic.zens10.com/'+ele.video" alt=""></video>
                  <div class="hover" v-if="imgType">
                    <i class="icon-delete" @click="imgRemove"></i>
                  </div>
                </div>
                <el-upload
                  :action="'https://up-as0.qiniup.com'"
                  :data="uploadObj"
                  list-type="picture-card"
                  :before-upload="beforeUploadVideo"
                  :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index,num)}"
                  :on-progress="handleProgressImg"
                  :on-remove="(response, file, fileList)=>{return handleRemoveVideo(response, file, fileList,index)}">
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img
                    width="100%"
                    :src="'https://speakiopic.zens10.com/' + ele.video"
                    alt=""
                  />
                </el-dialog>
              </div>
            </div>
            
            <div class="write-txt question-title">
              <p class="write-title">标题<span>*</span></p>
              <div class="write-text">
                <textarea  placeholder="" class="" v-model="item.title"></textarea>  
              </div>
            </div>
            <div class="question-list">
              <p>{{item.topic}}</p>
              <div class="question-item" v-for="(ele,num) in item.topics" v-bind:key="ele.id">
                <div class="question-item-title">
                  <p>问题{{(num+1)}}</p>
                  <button class="btn btn-add" v-if="(num+1) == item.topics.length" @click="questionAdd(ele,num,index)">添加问题</button>
                  <button class="btn btn-remove" @click="questionRemove(ele,num,index)">删除问题</button>
                </div>
                <div class="question-item-txt write-txt">
                  <p class="write-title">问题名称<span>*</span></p>
                  <div class="write-text">
                    <textarea  placeholder="" class="" v-model="ele.topic"></textarea>  
                    <span>最多输入50个中/英、数字和特殊符号</span>
                  </div>
                </div>
                <div class="question-item-txt write-txt">
                  <p class="write-title">AI提示词<span>*</span></p>
                  <div class="write-text">
                    <textarea  placeholder="" class="" v-model="ele.topic_ai"></textarea>  
                    <span>最多输入3000个中/英、数字和特殊符号</span>
                  </div>
                </div>
                <div class="question-item-txt write-txt">
                  <p class="write-title">是否必填/必选<span>*</span></p>
                  <div class="write-text" style="margin-top: 0;">
                    <el-radio v-model="ele.is_must" label="1">是</el-radio>
                    <el-radio v-model="ele.is_must" label="0">否</el-radio>
                  </div>
                </div>
                <div class="question-item-txt write-txt">
                  <p class="write-title">选择问题类型<span>*</span></p>
                  <div class="write-text" style="margin-top: 0;">
                    <el-radio v-model="ele.topic_type" label="1" @input="questionType(ele,index,num)">填空</el-radio>
                    <el-radio v-model="ele.topic_type" label="2" @input="questionType(ele,index,num)">单选</el-radio>
                  </div>
                </div>
                <div class="question-item-txt write-txt" v-if="ele.topic_type == 1">
                  <p class="write-title">填空提示<span>*</span></p>
                  <div class="write-text">
                    <textarea  placeholder="" class="" v-model="ele.fib"></textarea>  
                  </div>
                </div>
                <div class="optionList" v-else>
                  <div class="question-item-txt write-txt" v-for="(txt,k) in ele.option" v-bind:key="k">
                    <p class="write-title">选项{{(k+1)}}<span>*</span></p>
                    <div class="write-text">
                      <textarea  placeholder="" class="" v-model="ele.option[k]"></textarea>
                      <button class="btn btn-option-add" v-if="(k+1)==ele.option.length" @click="optionAdd(index,num)">添加选项</button>
                      <button class="btn btn-option-remove" @click="optionRemove(index,num,k)">删除选项</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="questionSub">保存</button>
          <button class="btn btn-close" @click="ModelHide">取消</button>
        </div>
      </div>

      <!-- 单人练习 -->
      <div class="MobelBox" v-if="addType == 'exam'">
        <div class="write-txt">
          <p class="write-title">标题<span>*</span></p>
          <div class="write-text">
            <textarea v-model="examObj.title"
              placeholder="最多输入50个中/英、数字和特殊符号"
            ></textarea>
            <span>最多输入50个中/英、数字和特殊符号</span>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="examSub">保存</button>
          <button class="btn btn-close" @click="ModelHide">取消</button>
        </div>
      </div>

      <!-- 对话练习 -->
      <div class="MobelBox" v-if="addType == 'dialogue'">
        <div class="write-txt" v-for="item in dialogueObj.problem" v-bind:key="item.id">
          <p class="write-title">任务{{item.id}} 标题<span>*</span></p>
          <div class="write-text">
            <textarea v-model="item.title"
              placeholder="最多输入50个中/英、数字和特殊符号"
            ></textarea>
            <span>最多输入50个中/英、数字和特殊符号</span>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">提示词<span>*</span></p>
          <div class="write-text">
            <textarea v-model="dialogueObj.problem_ai"
              placeholder="最多输入3000个中/英、数字和特殊符号"
            ></textarea>
            <span>最多输入3000个中/英、数字和特殊符号</span>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="dialogueSub">保存</button>
          <button class="btn btn-close" @click="ModelHide">取消</button>
        </div>
      </div>

      <!-- ai点评 -->
      <div class="MobelBox aiBox" v-if="addType == 'ai'">
        <div class="write-txt">
          <p class="write-title">单人AI提示词<span>*</span></p>
          <div class="write-msg">
            <p>朗读内容：【带入用户朗读的文字稿】</p>
          </div>
          <div class="write-text">
            <textarea v-model="aiObj.single_person_ai"
              placeholder="最多输入3000个中/英、数字和特殊符号"
            ></textarea>
            <span>最多输入3000个中/英、数字和特殊符号</span>
          </div>
          <div class="dimension">
            <div class="dimension-txt" v-for="(item,index) in aiObj.single_person_dim" :key="index">
              <p><span>*</span>维度{{index+1}}：</p>
              <input type="text" v-model="aiObj.single_person_dim[index]">
            </div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">对话AI提示词*<span>*</span></p>
          <div class="write-msg">
            <p>朗读内容：【带入用户朗读的文字稿】</p>
          </div>
          <div class="write-text">
            <textarea v-model="aiObj.dialogue_ai"
              placeholder="最多输入3000个中/英、数字和特殊符号"
            ></textarea>
            <span>最多输入3000个中/英、数字和特殊符号</span>
          </div>
          <div class="dimension">
            <div class="dimension-txt" v-for="(item,index) in aiObj.dialogue_dim" :key="index">
              <p><span>*</span>维度{{index+1}}：</p>
              <input type="text" :class="item" v-model="aiObj.dialogue_dim[index]">
            </div>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="aiSub">保存</button>
          <button class="btn btn-close" @click="ModelHide">取消</button>
        </div>
      </div>

      <!-- 文稿 -->
      <div class="MobelBox aiBox" v-if="addType == 'write'">
        <div class="write-txt" v-for="(item,index) in writeObj.videos" :key="index">
          <p class="write-title">上传{{item.name}}视频<span class="hide">*</span></p>
          <div class="write-text" style="width: 80%;display: inline-block;">
            <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="item.video">
              <video :src="'https://speakiopic.zens10.com/'+item.video" alt=""></video>
              <div class="hover" v-if="imgType">
                <i class="icon-delete" @click="imgRemove"></i>
              </div>
            </div>
            <el-upload
              :action="'https://up-as0.qiniup.com'"
              :data="uploadObj"
              list-type="picture-card"
              :before-upload="beforeUploadVideo"
              :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index)}"
              :on-progress="handleProgressImg"
              :on-remove="(response, file, fileList)=>{return handleRemoveVideo(response, file, fileList,index)}">
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img
                width="100%"
                :src="'https://speakiopic.zens10.com/' + writeObj.video"
                alt=""
              />
            </el-dialog>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">标题<span>*</span></p>
          <div class="write-text">
            <textarea v-model="writeObj.title"
              placeholder="最多输入50个中/英、数字和特殊符号"
            ></textarea>
            <span>最多输入50个中/英、数字和特殊符号</span>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="writeSub">保存</button>
          <button class="btn btn-close" @click="ModelHide">取消</button>
        </div>
      </div>

      <div class="organiza-txt" v-if="addType == ''">
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="" />
            <p>添加演讲</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">
              {{ item.title }}
            </p>
          </div>
          <div class="dataList">
            <div
              class="listItem"
              v-for="(item, index) in dataList"
              v-bind:key="index + 1"
            >
              <p :title="item.key">{{ item.key }}</p>
              <p :title="item.title">{{ item.title }}</p>
              <p :title="item.subtitle">{{ item.subtitle }}</p>
              <p :title="item.type_name">{{ item.type_name }}</p>
              <p :title="item.type_name">
                <img :src="'https://speakiopic.zens10.com/'+item.image" alt=""/>
              </p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.publish_status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB"
                >
                </el-switch>
              </p>
              <p :title="item.publish_time">{{ item.publish_time }}</p>
              <p :title="item.create_time">{{ item.create_time }}</p>
              <p>
                <button title="编辑" class="btn btn-build" @click="getDetail(item,'exit')">编辑</button>
                <button title="说明" class="btn btn-describe" @click="getDetail(item,'describe')">说明</button>
                <button title="单人练习" class="btn btn-question" @click="getDetail(item,'exam')" v-if="item.use.indexOf('11') > -1 || item.use.indexOf(11) > -1">
                  单人练习
                </button>
                <button title="对话练习" class="btn btn-question" @click="getDetail(item,'dialogue')" v-if="item.use.indexOf('12') > -1 || item.use.indexOf(12) > -1">
                  对话练习
                </button>
                <button title="AI点评" class="btn btn-question" @click="getDetail(item,'ai')">AI点评</button>
                <button title="提问" class="btn btn-question" @click="getDetail(item,'question')" v-if="item.use.indexOf('21') > -1 || item.use.indexOf(21) > -1">提问</button>
                <button title="输入文稿" class="btn btn-question" @click="getDetail(item,'write')" v-if="item.use.indexOf('22') > -1 || item.use.indexOf(22) > -1">
                  输入文稿
                </button>
              </p>
            </div>
          </div>

          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close">取消</button>
          <button class="btn btn-sub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUploadToken,getSpeechTypeUseList,saveSpeech,getSpeechList,updateSpeechStatus,saveSpeechDetail,saveSpeechText,saveSpeechSub,getSpeechDetail,getDigitalHumanUserList } from "@/assets/js/api";
import navBox from "./../components/comment/nav.vue";
import myHeader from "./../components/comment/myHeader.vue";
export default {
  name: "speech",
  data() {
    return {
      navId: "2",
      childrenID: "2-1",
      titleList: [
        { id: 1, title: "序号" },
        { id: 2, title: "标题" },
        { id: 3, title: "副标题" },
        { id: 4, title: "类型" },
        { id: 5, title: "封面" },
        { id: 6, title: "发布状态" },
        { id: 7, title: "发布时间" },
        { id: 8, title: "添加时间" },
        { id: 9, title: "操作" },
      ],
      dataList: [],
      addType: "",
      removeType: false,
      typelist: [],
      value: "",
      uploadObj: {
        token: "",
        key: "",
      },
      uploadUrl: "",
      dialogVisible: false,
      addObj: {
        type_id:'',
        title:'',
        subtitle:'',
        image:'',
        use:[],
        static_videos:[],
      },
      token:'',
      totalPage:0,
      describeObj:{},
      questionObj:{},
      examObj:{},
      dialogueObj:{},
      aiObj:{},
      writeObj:{},
      imgType:false,
      loading:false,
      loadTxt:'',
      checkList: [
        {id:'11',title:'单人练习',checked:false},
        {id:'12',title:'对话练习',checked:false},
        {id:'21',title:'提问',checked:false},
        {id:'22',title:'输入文稿',checked:false},
      ],
      obj:{
        page:1,
        rows:10
      },
      userList:[],
      videoList:[]
    };
  },
  components: {
    navBox,
    myHeader,
  },
  mounted() {
    var that = this;
    this.token = localStorage.getItem('token');
    this.getToken();
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };

      try {
        const response = await getSpeechTypeUseList(this.token);
        if(response.code == 200){
          that.typelist = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getDigitalHumanUserList(this.token);
        if(response.code == 200){
          response.data.forEach(function(item,index){
            that.videoList.push({id:item.id,video:'',name:item.name});
          })
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    async getList() {
      var that = this;
      try {
        const response = await getSpeechList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.publish_status==0){
              item.publish_status=false
            } else {
              item.publish_status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getDetail(e,type){
      var that = this;
      try {
        const response = await getSpeechDetail({id:e.id},this.token);
        if(response.code == 200){
          
          that.addType = type;
          if(type == 'exit'){
            that.addObj = {
              title:response.data.title,
              subtitle:response.data.subtitle,
              type_id:response.data.type_id,
              image:response.data.image,
              static_video:response.data.static_video,
              use:response.data.use,
              id:response.data.id,
              static_videos:response.data.static_videos.length>0?response.data.static_videos:that.videoList
            };
            response.data.use.forEach(function(item,index){
              that.checkList.forEach(function(ele,num){
                if(item == ele.id){
                  ele.checked = true
                }
              })
            });
          } else if(type == 'describe'){
            // that.describeShow();
            that.describeObj = {
              id:e.id,
              type:1,
              content:response.data.content,
            };
            if(response.data.videos){
              if(response.data.videos.length > 0){
                that.describeObj.videos = response.data.videos;
              } else {
                that.describeObj.videos = that.videoList;
              }
            } else {
              that.describeObj.videos = that.videoList;
            }
          } else if(type == 'exam'){
            that.examObj = {
              id:e.id,
              type:1,
              title:response.data.single.title?response.data.single.title:'',
            };
            if(response.data.single.sid){
              that.examObj.sid = response.data.single.sid
            }
          } else if(type == 'dialogue'){
            that.dialogueObj = {
              id:e.id,
              type:2,
              problem:response.data.dialog.problem?response.data.dialog.problem:'',
              problem_ai:response.data.dialog.problem_ai?response.data.dialog.problem_ai:'',
            };
            if(response.data.dialog.length == 0){
              that.dialogueObj.problem = [
                {id:1,title:''},
                {id:2,title:''},
                {id:3,title:''},
                {id:4,title:''},
                {id:5,title:''},
              ]
            }
            if(response.data.dialog.sid){
              that.dialogueObj.sid = response.data.dialog.sid
            };
          } else if(type == 'ai'){
            that.aiObj = {
              id:e.id,
              type:2,
              single_person_ai:response.data.single_person_ai,
              single_person_dim:response.data.single_person_dim?response.data.single_person_dim:['','','','',''],
              dialogue_ai:response.data.dialogue_ai,
              dialogue_dim:response.data.dialogue_dim?response.data.dialogue_dim:['','','','',''],
            }
          } else if(type == 'write'){
            that.writeObj = {
              id:e.id,
              type:2,
              videos:response.data.import.length>0?response.data.import.videos:JSON.parse(JSON.stringify(that.videoList)),
              title:response.data.import.title?response.data.import.title:'',
            };
            if(response.data.import.tid){
              that.writeObj.tid = response.data.import.tid
            };
          } else if(type == 'question'){
            that.questionObj = {
              // data.data.create.
              id:e.id,
              type:1,
              speech_text_ai: response.data.create.speech_text_ai?response.data.create.speech_text_ai:'',
              challenge_problem_ai: response.data.create.challenge_problem_ai?response.data.create.challenge_problem_ai:'',
              progress_num:response.data.create.progress_num?response.data.create.progress_num:'',
              progress:response.data.create.progress?response.data.create.progress:[],
            }
            if(that.questionObj.progress){
              that.questionObj.progress.forEach(function(item,index){
                item.topics.forEach(function(ele,num){
                  ele.is_must = JSON.stringify(ele.is_must)
                  ele.topic_type = JSON.stringify(ele.topic_type)
                });
                if(item.videos.length == 0){
                  item.videos = JSON.parse(JSON.stringify(that.videoList))
                }
              })
            }
            if(response.data.create.tid){
              that.questionObj.tid = response.data.create.tid
            };
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async switchChange(e) {
      var that = this;
      var obj = {
        id:e.id,
        publish_status:e.publish_status==false?0:1,
      };
      try {
        const response = await updateSpeechStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
        } else {
          that.$message(response.msg);
          e.publish_status = !e.publish_status;
        }
      } catch (error) {
        that.$message(error);
        e.publish_status = !e.publish_status;
      }
    },

    beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    beforeUploadVideo(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },
    
    handleSuccessImg(response, file, fileList) {
      this.addObj.image = response.key;
      this.loading = false;
      this.uploadObj.key = "";
    },

    handleSuccessVideo(response, file, fileList,index,type) {
      if(this.addType == 'describe'){
        // this.describeObj.video = response.key;
        this.describeObj.videos[index].video = response.key;
      } else if(this.addType == 'question'){
        this.questionObj.progress[index].videos[parseInt(type)].video =  response.key;
      }  else if(this.addType == 'exam'){
        this.examObj.video =  response.key;
      } else if(this.addType == 'dialogue'){
        this.dialogueObj.video = response.key;
      } else if(this.addType == 'write'){
        // this.writeObj.video = response.key;
        this.writeObj.videos[index].video = response.key;
      } else {
        // this.addObj.static_video = response.key;
        if(type == 'num'){
          this.addObj.static_videos[index].video = response.key;
        }
      };
      this.loading = false;
      this.uploadObj.key = "";
    },
  
    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
    },

    handleRemoveVideo(response, file, fileList,index) {
      if(this.addType == 'describe'){
        this.describeObj.video ='';
      } else if(this.addType == 'question'){
        this.questionObj.progress[index].video =  '';
      } else if(this.addType == 'exam'){
        this.examObj.video = '';
      } else if(this.addType == 'dialogue'){
        this.dialogueObj.video = '';
      } else if(this.addType == 'write'){
        this.writeObj.video = '';
      } else {
        this.addObj.static_video = "";
      }
    },
 

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(response, file, fileList){
      this.courseObj.content = response.key;
      this.loading = false;
      this.uploadObj.key = '';
    },
    handleRemove(file, fileList) {
      this.courseObj.content = '';
    },
    beforeUpload(file){
      var that = this;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb"
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("不支持的文件类型");
        return false;
      }

      var url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      var duration;
      audioElement.addEventListener("loadedmetadata", function(_event) {
        duration = audioElement.duration; //时长为秒，小数，182.36
        // this.$parent.$data.wDuration = parseInt(duration);
        that.courseObj.length = duration;
      });
      
      this.loading = true;
    },
    handleProgress(event, file, fileList) {
      // event 是一个包含 loaded 和 total 两个属性的对象
      // console.log('上传进度', Math.round((event.loaded / event.total) * 100) + '%');
      // console.log(file.percentage.toFixed(0))
      this.loadTxt = '已上传' + file.percentage.toFixed(0) + '%';
      // this.loadTxt = '上传中，请稍后';
      // 这里可以获取到上传进度，并根据需要更新UI
    },

    addSub(){
      var that = this;
      this.addType = 'add';
      this.addObj.static_videos = that.videoList;
    },

    async saveSub(){
      var that = this;
      that.addObj.use = [];
      this.checkList.forEach(function(item,index){
        if(item.checked){
          that.addObj.use.push(item.id)
        }
      });
      if(this.addObj.title == ''){
        that.$message('请输入标题');
        return false;
      }
      if(this.addObj.subtitle == ''){
        that.$message('请输入副标题');
        return false;
      }
      if(this.addObj.type_id == ''){
        that.$message('请选择类型');
        return false;
      }
      if(this.addObj.image == ''){
        that.$message('请上传封面');
        return false;
      }
      

  
      try {
        const response = await saveSpeech(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.getList();
          that.ModelHide();  
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      if(this.headID == 1){
        this.ExerSet.img = '';
      } else {
        this.TestSet.img = '';
      };
    },

    ModelHide(){
      this.addType = '';
      this.describeObj={};
      this.questionObj={};
      this.examObj={};
      this.dialogueObj = {};
      this.addObj = {};
    },

    describeShow(e){
      var that = this;
      this.addType = 'describe';
      this.describeObj.type = 1;
      this.describeObj.id = e.id;
    },

    async describeSub(){
      var that = this;
      if(this.describeObj.video ==''){
        that.$message('请先上传视频！');
        return false;
      }
      if(this.describeObj.content ==''){
        that.$message('请填写详情！');
        return false;
      }
      try {
        const response = await saveSpeechDetail(this.describeObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.getList();
          that.ModelHide();    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    questionShow(e){
      this.addType = 'question';
      this.questionObj = {
        id:e.id,
        type:1,
        speech_text_ai:'',
        challenge_problem_ai:'',
        progress_num:1,
        progress:[
          {video:'',title:'',topics:[{topic:'', topic_ai:'',is_must:'1',topic_type:'1',fib:'',}]}
        ]
      };
    },

    async questionSub(){
      var that = this;
      if(this.questionObj.speech_text_ai == ''){
        that.$message('请填写生成演讲稿提示词！');
        return false;
      }
      if(this.questionObj.challenge_problem_ai == ''){
        that.$message('请填写挑战问题提示词！');
        return false;
      }
      if(this.questionObj.progress_num == ''){
        that.$message('请填写进度！');
        return false;
      }
      
      try {
        const response = await saveSpeechText(this.questionObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.getList();
          that.ModelHide();   
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    examShow(e){
      this.addType = 'exam';
      this.examObj = {
        id:e.id,
        type:1,
        title:'',
      };
    },

    async examSub(){
      var that = this;
      if(this.examObj.title == ''){
        that.$message('请填写标题！');
        return false;
      }
      try {
        const response = await saveSpeechSub(this.examObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.getList();
          that.ModelHide();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },


    async writeSub(){
      var that = this;
      if(this.writeObj.title == ''){
        that.$message('请填写标题！');
        return false;
      }
      try {
        const response = await saveSpeechText(this.writeObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.getList();
          that.ModelHide();   
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async aiSub(){
      var that = this;
      if(this.aiObj.single_person_ai ==''){
        that.$message('请填写单人演讲ai提示词！');
        return false;
      }
      if(this.aiObj.dialogue_ai ==''){
        that.$message('请填写对话演讲ai提示词！');
        return false;
      }
      try {
        const response = await saveSpeechDetail(this.aiObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.getList();
          that.ModelHide();    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async dialogueSub(){
      var that = this;
      try {
        that.dialogueObj.problem.forEach(function(item,index){
          if(item.title == ''){
            that.$message('请填写任务'+(index+1)+'标题！');
            throw new Error("EndIterative");
          }
        })
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
      
      if(this.dialogueObj.problem_ai == ''){
        that.$message('请填写提示词！');
        return false;
      }

      try {
        const response = await saveSpeechSub(this.dialogueObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.getList();
          that.ModelHide();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    createSub(){
      var that = this;
      if(this.questionObj.progress.length==0){
        for(var i = 0;i < this.questionObj.progress_num;i++){
          this.questionObj.progress.push({
            num:(i+1),
            videos:JSON.parse(JSON.stringify(that.videoList)),
            topics:[
              {
                topic:'',
                topic_ai:'',
                is_must:'1',
                topic_type:'1',
                fib:'',
                option:[],
              }
            ]
          })
        };
      } else {
        if(this.questionObj.progress.length < this.questionObj.progress_num){
          var num = this.questionObj.progress_num - this.questionObj.progress.length;
          for(var i = 0;i < num;i ++){
            this.questionObj.progress.push({
              num:(this.questionObj.progress.length+1),
              videos:JSON.parse(JSON.stringify(that.videoList)),
              topics:[
                {
                  topic:'',
                  topic_ai:'',
                  is_must:'1',
                  topic_type:'1',
                  fib:'',
                  option:[],
                }
              ]
            })
          }
        } else {
          var num = this.questionObj.progress.length - this.questionObj.progress_num;
          var list = this.questionObj.progress.slice(0,this.questionObj.progress_num);
          this.questionObj.progress = list;

        }
      };
    },

    questionType(e,i,num){
      var list = this.questionObj.progress;
      if(e.topic_type == 2){
        if(list[i].topics[num].option.length == 0){
          list[i].topics[num].option.push('')
        }
      }
    },

    optionAdd(index,num){
      var optionList = this.questionObj.progress[index].topics[num].option;
      optionList.push('');
    },

    optionRemove(index,num,k){
      var optionList = this.questionObj.progress[index].topics[num].option;
      optionList.splice(k,1)
    },

    questionAdd(e,n,index){
      var list = this.questionObj.progress[index].topics;
      list.push({
        topic:'',
        topic_ai:'',
        is_must:'1',
        topic_type:'1',
        fib:'',
        option:[],
      })
    },

    questionRemove(e,n,index){
      var list = this.questionObj.progress[index].topics;
      list.splice(n,1)
    },

    checkSub(e){
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p {
  width: calc(100% / 9);
}

.organiza-list p img{
  width: 100%;
}

.listItem p .btn {
  display: inline-block;
  vertical-align: top;
  color: #6e2fff;
  font-size: 14px;
}

.MobelBox {
  padding: 40px;
  box-sizing: border-box;
  width: 100%;
  height: calc( 100% - 100px );
  overflow-y: auto;
  overflow-x: hidden;
}

.MobelBox .write-txt {
  display: block;
  width: 100%;
  margin-bottom: 40px;
}

.MobelBox .write-title {
  font-size: 18px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  width: 160px;
}

.MobelBox .write-title span {
  color: #e2231a;
}

.MobelBox .write-text {
  display: inline-block;
  vertical-align: top;
  width: 80%;
  margin-left: 20px;
}

.MobelBox .write-text span {
  font-size: 14px;
  color: #e2231a;
  margin-top: 10px;
  display: block;
}

.MobelBox textarea {
  width: 80%;
  height: 65px;
  background-color: #f5f5f5;
  border-radius: 16px;
  display: block;
  padding: 10px;
  box-sizing: border-box;
}

.write-btnBox {
  float: right;
  width: 100%;
  text-align: right;
}

.write-btnBox .btn {
  width: 120px;
  height: 56px;
  line-height: 56px;
  border-radius: 16px;
  color: #fff;
  background-color: #6e2fff;
  padding: 0;
  margin: 0;
  font-size: 20px;
}

.write-btnBox .btn.btn-close {
  color: #999999;
  background-color: #f5f5f5;
  margin-left: 40px;
}

.msgBox .contv {
  padding: 40px 73px;
  border-radius: 32px;
}

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.questionBox .write-txt .write-text {
  width: 100%;
  display: block;
}

.questionBox .write-txt .write-text textarea {
  height: 140px;
}

.questionBox .write-num {
  border-top: solid 20px #F5F5F5;
  padding-top: 20px;
}

.questionBox .write-num .write-text  {
  display: inline-block;
  vertical-align: top;
  width: auto;
  margin: 0 0 0 68px;
}

.questionBox .write-txt .write-text input {
  height: 65px;
  width: 142px;
  border-radius: 16px;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  background-color: #F5F5F5;
}

.uploadList{
  display: block;
}

.questionBox .uploadList .question-title .write-text{
  display: inline-block;
  vertical-align: top;
  width: 80%;
  margin: 0 0 0 30px;
}

.question-item-title {
  margin-bottom: 20px;
}

.question-item-title p{
  color: #333333;
  font-size: 18px;
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
}

.question-item-title .btn{
  width: 140px;
  height: 47px;
  line-height: 47px;
  color: #fff;
  background-color: #6E2FFF;
  border-radius: 8px;
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
}

.question-item-title .btn.btn-remove{
  background-color: #E2231A;
}

.questionBox .question-item-txt .write-text{
  display: inline-block;
  vertical-align: top;
  width: 80%;
  margin-left: 20px;
}

.write-text>>>.el-radio__inner{
  width: 20px;
  height: 20px;
}

.write-text>>>.el-radio__label{
  font-size: 18px;
}

.aiBox.MobelBox .write-msg{
  display: inline-block;
  vertical-align: top;
}

.aiBox.MobelBox .write-msg p{
  color: #6E2FFF;
  font-size: 18px;
}

.aiBox.MobelBox .write-text{
  width: 100%;
  display: block;
  margin: 10px 0 0 ;
}

.upload-title{
  font-size: 18px;
  color: #333333;
  display: block;
  margin: 56px 0 10px;
}

.upload-title::before{
  content: '';
  width: 4px;
  height: 26px;
  display: inline-block;
  vertical-align: top;
  background-color: #6E2FFF;
  border-radius: 16px;
  margin-right: 10px;
}

.write-text .img{
  width: 148px;
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
  position: relative;
}

.write-text .img video,
.write-text .img img{
  width: 100%;
}

.write-text .img .hover{
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .6);
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}

.write-text .img .icon-delete{
  background-image: url(~@/assets/images/btn-remove.png);
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.btn-create{
  display: inline-block;
  vertical-align: top;
  width: 116px;
  height: 53px;
  background-color: #6E2FFF;
  border-radius: 16px;
  color: #fff;
  padding: 0;
  margin: 0 30px 0 0;
  outline: none;
  font-size: 18px;
}

.optionList .write-text textarea,
.optionList .write-text .btn{
  display: inline-block;
  vertical-align: top ;
}

.questionBox .optionList .write-text textarea{
  width: 60%;
  height: 65px;
}

.optionList .write-text .btn{
  padding: 11px 20px;
  box-sizing: border-box;
  color: #fff;
  font-size: 18px;
  background-color: #6E2FFF;
  margin-left: 20px;
  outline: none;
  border-radius: 8px;
}

.dimension{
  display: block;
}

.dimension .dimension-txt {
  display: block;
  margin: 5px 0;
}

.dimension .dimension-txt p{
  font-size: 14px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
}

.dimension .dimension-txt p span{
  color: #E2231A;
}

.dimension .dimension-txt input{
  display: inline-block;
  vertical-align: top;
  background-color: #f5f5f5;
  width: 200px;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
  margin-left: 10px;
  box-sizing: border-box;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/speech/speech.vue